import { Fragment, useCallback, useEffect, useState } from "react";
import { Button, Grid, TextField } from "@mui/material";

import { StyledStack, ButtonContainer, StyledTitle } from "./slides.styles";
import DrawerCM from "components/shared/Drawer";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import useHttp from "hooks/use-http";

import { validateImg, slideContentSchema } from "validations";

// material icons
import CheckIcon from "@mui/icons-material/Check";

import {
  addSlidesImageRequest,
  deleteSlidesImageRequest,
  getSlidesImageRequest,
} from "api/requests/slides";
import DeleteModal from "components/shared/Modal/Delete";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MediaCard from "components/MedaiCard";

function Slides() {
  const [image, setImage] = useState({ data: [], count: 0 });
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(slideContentSchema),
  });

  // upload image state
  const [slideImage, setSlideImage] = useState({
    url: null,
    isChanged: false,
  });

  // uploaded image handler
  const handleImageChange = (val) => {
    validateImg(val);
    setSlideImage({
      url: val,
      isChanged: true,
    });
  };

  const onSubmit = async (data) => {
    if (!slideImage.url) return Toast({ type: "empty", title: "فیلد عکس " });
    const res = await request({
      url: () =>
        addSlidesImageRequest(
          {
            ...data,
            image: slideImage,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "آپلود عکس" });
      setSlideImage({
        url: null,
        isChanged: false,
      });
      reset({
        title: "",
        alt: "",
        text: "",
        link: "",
        keyword: "",
      });
      getImages();
    }
  };

  const getImages = useCallback(async () => {
    const res = await request({
      url: getSlidesImageRequest,
    });

    if (res) {
      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        image: items.image,
        title: items.title,
        text: items.text,
      }));

      setImage({ data: transformedData, count: res.data.count });
    }
  }, [request]);

  useEffect(() => {
    getImages();
  }, [getImages]);

  return (
    <Fragment>
      <DrawerCM title="تصاویر اسلاید صفحه اصلی">
        {isUploading ? (
          <ProgressBarCM value={uploadProgress} />
        ) : loading ? (
          <LoadingCM />
        ) : (
          <Grid container my={2} spacing={2}>
            <StyledStack>
              <StyledTitle>افزودن اسلاید </StyledTitle>
              <Grid container my={1} spacing={2}>
                <Grid item md={6} xs={12}>
                  {slideImage.url ? (
                    <Upload
                      isWeb={slideImage.isWeb}
                      isLocal={!slideImage.isWeb}
                      file={slideImage.url}
                      refillable
                      type="add-slide-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  ) : (
                    <Upload
                      isLocal={slideImage.isChanged}
                      file={slideImage.url}
                      refillable
                      type="add-slide-image"
                      onChange={handleImageChange}
                      width={"100%"}
                      height={"100%"}
                      objectFit="contain"
                    />
                  )}
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="متن"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={6}
                    id="image_text"
                    {...register("text")}
                    error={Boolean(errors.text)}
                    helperText={errors.text?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="عنوان"
                    variant="outlined"
                    fullWidth
                    id="title"
                    {...register("title")}
                    error={Boolean(errors.title)}
                    helperText={errors.title?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="لینک"
                    variant="outlined"
                    fullWidth
                    id="link"
                    {...register("link")}
                    error={Boolean(errors.link)}
                    helperText={errors.link?.message}
                  />
                </Grid>

                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="متن جایگزین"
                    variant="outlined"
                    fullWidth
                    id="alt"
                    {...register("alt")}
                    error={Boolean(errors.alt)}
                    helperText={errors.alt?.message}
                  />
                </Grid>
                <Grid item md={6} xs={12} p={1.2}>
                  <TextField
                    label="کلمه کلیدی"
                    variant="outlined"
                    fullWidth
                    id="keyword"
                    {...register("keyword")}
                    error={Boolean(errors.keyword)}
                    helperText={errors.keyword?.message}
                  />
                </Grid>
                <ButtonContainer>
                  <Button
                    startIcon={<CheckIcon />}
                    variant="contained"
                    sx={{ mt: 1 }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    ذخیره
                  </Button>
                </ButtonContainer>
              </Grid>
            </StyledStack>
            <StyledStack>
              <Grid container my={1} spacing={2}>
                {image.data.map((img, index) => {
                  return (
                    <Grid
                      item
                      md={4}
                      sm={6}
                      xs={12}
                      key={"slides-img" + index}
                      p={3}
                    >
                      <MediaCard item={img} />
                    </Grid>
                  );
                })}
              </Grid>
            </StyledStack>
          </Grid>
        )}
      </DrawerCM>
    </Fragment>
  );
}
export default Slides;
